import type { TranslationKey } from '@change-corgi/core/i18n';

import { getUploadErrorMessages, getUploadErrorReason, UploadError } from '#src/app/shared/utils/uppyUploader';

import type { UppyFileType } from '../../types';

export type UseUploaderProps = (errorMessage: TranslationKey) => void;

export const handleRestrictionFailed =
	(handleError: UseUploaderProps) =>
	(_file: UppyFileType | undefined, error: Error): void => {
		// Our own UploadError/RestrictionUploadError already carry a typed `reason` — reading it
		// directly avoids depending on error.message matching getUploadErrorReason's substring
		// patterns, which is only meant for Uppy's own native restriction errors (which have no
		// typed reason, only free-text messages).
		const reason = error instanceof UploadError ? error.reason : getUploadErrorReason(error.message);
		handleError(getUploadErrorMessages()[reason]);
	};
